















































































import mixins from 'vue-typed-mixins';
import cloneDeep from 'lodash.clonedeep';
import deepEqual from 'deep-equal';
import { Location } from 'vue-router';
import SurveyUtils, { Survey } from '../../utils/SurveyUtils';
import SurveyDuplicate from '@/components/survey/management/SurveyDuplicate.vue';
export default mixins().extend({
  components: {
    SurveyDuplicate,
  },

  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },

    tabs(): any {
      return [
        {
          text: this.$i18n.tc('app.label.detail', 2),
          location: { name: 'survey-edit-details' },
        },
        {
          text: this.$i18n.tc('model.surveyState.label', 2),
          location: { name: 'survey-edit-state' },
        },
        {
          text: this.$i18n.tc('model.question.label', 2),
          location: { name: 'survey-edit-questions' },
        },
        {
          text: this.$i18n.tc('page.survey.details.layoutTab'),
          location: { name: 'survey-edit-layout' },
        },
        {
          text: this.$i18n.tc('page.survey.details.previewTab'),
          location: {
            name: 'survey-edit-preview',
            params: {
              path: '1',
            },
          },
        },
        {
          text: this.$i18n.tc('model.surveyParticipation.label', 2),
          location: { name: 'survey-edit-participation' },
        },
        {
          text: this.$i18n.tc('model.dashboard.label', 2),
          location: { name: 'survey-dashboard-tiles' },
        },
      ];
    },

    tab(): undefined | number {
      return this.tabs?.findIndex(
        (tab: any) => this.$route.name === tab.location.name
      );
    },
  },

  data(): {
    pristine?: Partial<Survey>;
    survey?: Partial<Survey>;
    duplicateSurvey?: Survey;
    validation: string[];
  } {
    return {
      pristine: undefined,
      survey: undefined,
      duplicateSurvey: undefined,
      validation: [],
    };
  },

  async mounted() {
    await this.load();
  },

  methods: {
    async load() {
      this.$loading(true);
      try {
        if (this.id) {
          const resp = await Promise.all([SurveyUtils.api.survey.get(this.id)]);
          this.pristine = {
            id: resp[0].id,
            name: {
              admin: resp[0].name.admin || '',
              public: resp[0].name.public || this.$languageobj(),
            },
            state: resp[0].state || 'inactive',
            layout: resp[0].layout || [],
            surveygroup: resp[0].surveygroup || {},
            options: {
              documents: {
                value: resp[0]?.options?.documents?.value,
                text:
                  resp[0]?.options?.documents?.text ||
                  this.$languageobj('model.document.label', { choice: 2 }),
              },
            },
            filter: {
              providerTypes: resp[0].filter?.providerTypes || [],
              oversights: resp[0].filter?.oversights || [],
            },
            languageobjects: {
              organization:
                resp[0].languageobjects?.organization ||
                this.$languageobj('model.survey.organization'),
              suborg:
                resp[0].languageobjects?.suborg ||
                this.$languageobj('model.survey.suborg'),
              pointofservice:
                resp[0].languageobjects?.pointofservice ||
                this.$languageobj('model.survey.pointofservice'),
            },
            startdate: resp[0]?.startdate,
            closedate: resp[0]?.closedate,
            duedate: resp[0]?.duedate,
            defaultstate: resp[0].defaultstate || {},
            bookshelf: resp[0].bookshelf,
            dashboard: {
              canvas: {
                left: resp[0]?.dashboard?.canvas?.left || [],
                right: resp[0]?.dashboard?.canvas?.right || [],
              },
            },
          };
          this.survey = cloneDeep(this.pristine);
        }
      } catch (error) {
        this.$alert.show('load', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
      this.$loading(false);
    },

    async navigate(location: Location) {
      if (
        typeof location === 'string'
          ? this.$route.path !== location
          : this.$route.name !== location.name
      ) {
        let allowNavigation = !deepEqual(this.survey, this.pristine)
          ? await this.$confirm(
              this.$i18n.t('validation.confirmation.navigation').toString()
            )
          : true;

        if (allowNavigation) {
          await this.$router.push(location);
          this.survey = cloneDeep(this.pristine);
        }
      }
    },

    async submit() {
      if (this.survey) {
        try {
          this.$alert.hide('submit');
          await SurveyUtils.api.survey.update(this.survey);
          this.pristine = cloneDeep(this.survey);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.$languageobj('model.survey.label')],
            }),
          });
        } catch (error) {
          this.$alert.show('submit', {
            type: 'error',
            messages: this.$handleAPIError(error, this.$refs.observer),
          });
        }
      }
    },

    duplicate() {
      this.duplicateSurvey = cloneDeep(this.survey) as Survey;
    },

    async remove() {
      await this.$confirm(
        this.$i18n
          .t('validation.confirmation.delete', [this.survey?.name?.admin])
          .toString(),
        async () => {
          if (this.survey?.id) {
            this.$alert.hide('remove');
            await SurveyUtils.api.survey.remove(this.survey.id);
            await this.$router.push({ name: 'survey-list' });

            this.$toast.push({
              type: 'success',
              text: this.$languageobj('validation.success.delete', {
                values: [this.survey?.name?.admin],
              }),
            });
          }
        }
      );
    },

    handlePristine(pristine: Partial<Survey>) {
      this.pristine = {
        ...this.pristine,
        ...cloneDeep(pristine),
      };
    },

    async validate() {
      try {
        this.$alert.hide('validate');
        this.validation = await SurveyUtils.api.survey.validate(
          this.survey?.id as number
        );

        if (this.validation.length > 0) {
          this.$alert.hide('validate');
          (this.$refs.validate as any).open();
        } else {
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('page.survey.validate.success'),
          });
        }
      } catch (error) {
        this.$alert.show('validate', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
  watch: {
    '$route.params.id'() {
      this.load();
    },
  },
});
